import {
  ThemeSelectors,
  TypePhantom,
  pulseAnimationStyles,
} from "@at/design-system-foundation";
import styled from "styled-components";

export const YouMayAlsoLikeLoadingSkeleton = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  justify-content: center;
  width: 100%;
  margin: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)} 0;
`;

export const YouMayAlsoLikeLoadingBodyWindow = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  margin: ${({ theme }) =>
    `${ThemeSelectors.getGroupFourSpacing(
      theme,
    )} 0 ${ThemeSelectors.getGroupFiveSpacing(theme)}`};
  width: 100%;

  > * {
    place-self: center center;
    width: 100%;
  }
`;

export const YouMayAlsoLikeLoadingItem = styled.div`
  ${pulseAnimationStyles};
  height: 300px;
  min-width: 280px;
`;

export const YouMayAlsoLikeLoadingCTA = styled.div`
  ${pulseAnimationStyles};
  height: 40px;
  width: 200px;
`;

export const YouMayAlsoLikeHeading = styled(TypePhantom)`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;
